import { useState } from "react";
import { Layout, Menu } from "antd";
import { DownOutlined, LogoutOutlined, BankOutlined } from '@ant-design/icons';

import './Layout.css';

import { useSelector } from "react-redux";
import { signout } from "../../App";

const { Header } = Layout;

export const applicationHeaderColour = "#f5f5f8ff"
export const applicationSelectionColour = "#2C5BD5"
export const theme = "light"

export function onLogoutClick() {
	localStorage.setItem("switch_account", "false");
	signout()
}

export function onSwitchAccountClick(email) {
	localStorage.setItem('email', email);
	localStorage.setItem("switch_account", "true");
	signout()
}

export const menuItems = (user, setOpenMenu, openMenu) => {
	const username = user?.profile?.email ?? user?.profile?.upn
	const getAvatarText = (user) => {
		const userName = user?.profile?.name;

		if (userName) {
			const parts = userName.trim().split(/\s+/);

			if (parts.length >= 2) {
				return (parts[0][0] + parts[1][0]).toUpperCase();
			}
			return userName[0]?.toUpperCase();
		}

		return "U";
	};


	return {
		label: (
			<div className="logoutmenu-wrapper">
				<div
					className="id-avatar"
				>
					{getAvatarText(user)}
				</div>

				<div className="profile-container">
					<div className="logoutmenu-text">
						<span className="logoutmenu-name">{user?.profile?.name}</span>
						<span className="logoutmenu-email">{localStorage.getItem("accountName")}</span>
					</div>

					<DownOutlined
						className={`logoutmenu-dropdown-icon ${openMenu === "SubMenu" ? "open" : ""}`}
					// onClick={() => {
					// 	if (openMenu === '') {
					// 		setOpenMenu('SubMenu');
					// 	}
					// 	else {
					// 		setOpenMenu('');
					// 	}
					// }}
					/>
				</div>
			</div>
		),
		key: 'SubMenu',
		onMouseLeave: () => setOpenMenu(''),
		onMouseEnter: () => setOpenMenu('SubMenu'),
		onClick: () => setOpenMenu('SubMenu'),
		className: 'layout-toggle-button height-100per margin-right-10px',
		// icon: <IconComponent type="UserOutlined" onClick={() => setOpenMenu('SubMenu')} className="logout-menu-icons" />,
		children: [
			{
				label: <p className="menu-item-disabled logout-menu-name">
					{user?.profile?.name}
				</p>,
				key: 'name',
				className: "menu-item-disabled",
			},
			{
				label: username,
				key: 'email',
				className: "menu-item-disabled logout-menu-username",
			},
			{
				label: localStorage.getItem("accountName"),
				key: 'account-name',
				className: "menu-item-disabled menu-item-option",
				icon: <BankOutlined className="logout-menu-icons" />,
			},
			{
				label: "Logout",
				key: 'logout',
				className: "menu-item-option primary-color",
				icon: <LogoutOutlined className="logout-menu-icons" />,
				onClick: () => { onLogoutClick() }
			}
		],
	}
};

export const items: any = (user, setOpenMenu, openMenu) => {
	let menuItemsData: any = [];
	menuItemsData.push(menuItems(user, setOpenMenu, openMenu))
	return menuItemsData;
}

function AppMainHeader(props) {
	const [openMenu, setOpenMenu] = useState('')
	const user = useSelector((state: any) => state.auth.user);

	return <>
		{
			<Header className={"header"} style={{ backgroundImage: `linear-gradient(to right, ${applicationHeaderColour}, ${applicationHeaderColour}` }}>
				<div>

				</div>
				{props.button}
				<div className="logo">
					<img
						alt="Credenti"
						className={`credenti-image`}
						height={50}
						src={window.location.origin + '/Credenti_Logo.png'}
					/>
				</div>

				<Menu
					className="border-bottom-0 header-items-menu"
					theme={theme}
					style={{ backgroundColor: applicationHeaderColour, width: '100%' }}
					mode="horizontal"
					items={[]}
				/>

				<Menu className={`border-bottom-0 main-header-logout-menu`}
					openKeys={[openMenu]}
					theme={theme} mode="horizontal" style={{ backgroundColor: applicationHeaderColour }}
					id="logout-menu" items={items(user, setOpenMenu, openMenu)}
				/>
			</Header>
		}
	</>
}

export default AppMainHeader;
